import { render, staticRenderFns } from "./SLanguageIcon.vue?vue&type=template&id=d923b43a&scoped=true"
import script from "./sLanguageIcon.ts?vue&type=script&lang=ts&external"
export * from "./sLanguageIcon.ts?vue&type=script&lang=ts&external"
import style0 from "./SLanguageIcon.vue?vue&type=style&index=0&id=d923b43a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d923b43a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d923b43a')) {
      api.createRecord('d923b43a', component.options)
    } else {
      api.reload('d923b43a', component.options)
    }
    module.hot.accept("./SLanguageIcon.vue?vue&type=template&id=d923b43a&scoped=true", function () {
      api.rerender('d923b43a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-language-icon/SLanguageIcon.vue"
export default component.exports